<template>
  <div class="rich-text-container">
    <ModuleTitleView :title="data?.title"></ModuleTitleView>
    <div class="rich-text" v-html="data?.data"></div>
  </div>
</template>

<script setup>

import ModuleTitleView from "@/components/actricle/ModuleTitleView.vue";

const props = defineProps({
  jsonData: Object
})

const data = reactive(props.jsonData)

</script>
<script>
export default {
  name: 'RichTextView'
}
</script>

<style lang="less">
.rich-text-container {
  width: 100%;
  margin-top: 60px;
  overflow: hidden;

  .rich-text {
    margin-top: 40px;

    p {
      line-height: 2 !important;
      font-size: 16px !important;
      letter-spacing: 1px !important;
      color: var(--font-color) !important;
      font-family: 'Microsoft YaHei', serif !important;
    }

    p span {
      line-height: 2 !important;
      font-size: 16px !important;
      letter-spacing: 1px !important;
      color: var(--font-color) !important;
    }

    h6 {
      margin-top: 10px !important;
      margin-bottom: 10px !important;

      span {
        font-size: 14px !important;
        letter-spacing: 1px !important;
        font-weight: normal !important;
        color: rgba(127, 127, 127) !important;
      }
    }

    h5 {
      margin-top: 10px !important;
      margin-bottom: 10px !important;

      span {
        font-size: 16px !important;
        letter-spacing: 1px !important;
        font-weight: bold !important;
        color: var(--main-color) !important;
      }
    }

    p video {
      margin-bottom: 10px !important;
    }

    p > strong {
      line-height: 3 !important;
      font-size: 18px !important;
      color: var(--main-color) !important;
      letter-spacing: 1px !important;
      background-color: transparent !important;
    }

    p span strong {
      line-height: 3 !important;
      font-size: 18px !important;
      color: var(--main-color) !important;
      letter-spacing: 1px !important;
    }

    p span strong span {
      line-height: 3 !important;
      font-size: 18px !important;
      color: var(--main-color) !important;
      letter-spacing: 1px !important;
    }

    p strong span {
      line-height: 3 !important;
      font-size: 18px !important;
      color: var(--main-color) !important;
      letter-spacing: 1px !important;
    }

    p span img {
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }

    p img {
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }

    td img {
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }
  }
}
</style>
